import { useSelectorFactory } from "@src/store";
import { getIsModHiddenFactory } from "@src/store/slices/experienceBuilder/common/selectors/getIsModHiddenFactory";

/**
 * Whether this mod is currently toggled out of the merchant's own preview.
 *
 * Each control in a row asks for itself rather than being handed the answer by
 * the row: that way a control that must react to hidden-ness (the eye, delete)
 * carries its own rule, and a new one cannot ship having forgotten it.
 */
export const useIsModHidden = (modId: string) =>
  useSelectorFactory(getIsModHiddenFactory, modId);
